import script from "./RecordChip.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordChip.vue?vue&type=script&setup=true&lang=js"

import "./RecordChip.vue?vue&type=style&index=0&id=3611b8b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3611b8b1"]])

export default __exports__